import { ReactNode } from 'react';
import { VictoryChart, VictoryChartProps } from 'victory';
import { useCbsGraphMeasurements } from './useCbsGraphMeasurements';

export const ChartContainer = ({
	children,
	globalMin,
	globalMax,
	containerComponent,
	...props
}: {
	children: ReactNode;
	globalMin: number;
	globalMax: number;
	containerComponent: ReactNode;
} & VictoryChartProps) => {
	const { graphInlineSize, graphBlockSize } = useCbsGraphMeasurements();

	return (
		<VictoryChart
			height={graphBlockSize}
			width={graphInlineSize}
			domain={{ y: [globalMin, globalMax * 1.05] }} // tiny offset in globalMax to prevent lines to stick to the top of the chart
			containerComponent={containerComponent}
			{...props}
		>
			{children}
		</VictoryChart>
	);
};
